import { default as NEWPolicyDetails } from "./PolicyDetails";

export default function PolicyDetails() {
  return NEWPolicyDetails();
}
